<template>
  <div id="simple-info-block">
    <v-card class="simple-info-block">
      <v-card-title class="info-title" :class="{'is-practitioner': info.title.includes('Practitioner')}" @click="handleClick(info.title)">
        {{info.title}}
        <v-card-actions>
          <div class="action-edit" v-if="!info.disabled">
            <Img @click="openDialog" :src="getImgWithExt(['icons', 'add', 'svg'])" />
          </div>
        </v-card-actions>
      </v-card-title>
      <v-card-text>
        <div v-html="formattedData"
             class="info-text"
             @click="startEdit"
             v-if="!isEdit && info.data">
        </div>
        <div v-if="isEdit">
          <v-textarea v-model="notes" :auto-grow="true" @blur.stop="stopEdit"></v-textarea><!--@blur.stop="stopEdit"-->
        </div>
      </v-card-text>
    </v-card>
    <v-dialog
      v-if="isOpenDialog"
      :value="isOpenDialog"
      width="auto"
      height="auto"
      @keydown.esc="close"
    >
      <div v-click-outside="close">
        <v-card style="padding: 16px; border-radius: 16px; min-width: 350px; width: 40vw;">
          <v-card-title class="px-0 pt-0 d-flex justify-space-between">
          <span>
            {{info.title}}
          </span>
            <v-icon @click.native="close">mdi-close</v-icon>
          </v-card-title>

          <v-card-text style="width: 100%; height: 70%; max-height: 300px; overflow-y: auto; padding: 0 12px; border: 0">
            <v-textarea v-model="notes" :auto-grow="true" @keydown.shift.enter.stop="save"></v-textarea><!--@blur.stop="stopEdit"-->
          </v-card-text>

          <v-card-actions class="justify-end">
            <Button dark
                    btn-bg="dark-green"
                    height="45"
                    :styles="{ 'border-radius': '8px' }"
                    @click="save">
              Save
            </Button>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog
      v-if="isOpenReportView"
      :value="isOpenReportView"
      width="60%"
      @keydown.esc="closeReportView"
    >
      <div v-click-outside="closeReportView" style="min-height: 600px; height: 85vh ">
        <div v-if="loading" style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;margin: auto;" class="d-flex justify-center px-2 py-2 align-center">
          <v-progress-circular
            indeterminate
            color="#008C89"
          ></v-progress-circular>
        </div>
        <v-card-title class="d-flex justify-end" style="background-color: #ffffff">
          <v-icon @click.native="closeReportView" style="cursor: pointer">mdi-close</v-icon>
        </v-card-title>

        <iframe style="height: 100%; width: 100%" v-if="initialDoc" :src="initialDoc" />
      </div>
    </v-dialog>
  </div>
</template>

<script>

import Button from '@/components/elements/Button'
import { mapActions, mapMutations, mapState } from 'vuex'
import Image from '@/mixins/Image'

export default {
  props: {
    info: {
      type: Object
    },
    index: Number
  },
  name: 'simple-info-block',
  components: { Button },
  mixins: [Image],
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.__ClickOutsideHandler__ = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.__ClickOutsideHandler__);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null
      }
    }
  },
  data: () => ({
    isEdit: false,
    notes: null,
    isOpenDialog: false,
    isOpenReportView: false,
    file: null,
    fileUrl: null,
    initialDoc: null,
    loading: false,
  }),
  computed: {
    ...mapState({
      userProfile: state => state.userProfile,
    }),
    formattedData() {
      return this.info.data.replace(/\n/g, '<br>');
    }
  },
  mounted () {
    this.notes = this.info.data
  },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    ...mapActions('reports', ['gerReportByCode', 'sendSurveyForm', 'sendEmailToPatient', 'sendEmailToPatientMultiple', 'downloadZipReports']),

    startEdit () {
      if (!this.info.disabled) {
        this.notes = this.info.data
        this.isEdit = true
      }
    },
    stopEdit () {
      this.isEdit = false
      this.$emit('updateNote', { notes: this.notes, index: this.index, data: this.info })
    },
    openDialog () {
      this.isOpenDialog = true
      this.notes = this.info.data
    },
    close () {
      this.isOpenDialog = false
    },

    handleClick (title) {
      if(title.includes('Practitioner')) {
        this.$emit("closeSidebar")
        this.openReportView()
      }
    },

    async openReportView () {
      this.isOpenReportView = true
      this.loading = true
      this.notes = this.info.data

      const payload = {
        appUserId: this.userProfile.userId,
        reportCode: 'UIClinicianNotes',
        entityId: this.$route.params.id,
      }

      const res = await this.gerReportByCode(payload)
      this.file = res
      this.parseFile(this.file)
      this.initialDoc = 'https://pdftron.s3.amazonaws.com/downloads/pl/demo-annotated.pdf'
      this.loading = false
    },

    parseFile (file) {
      if (file) {
        const reader = new FileReader()
        reader.onloadend = () => {
          this.fileUrl = URL.createObjectURL(file)
          this.initialDoc = this.fileUrl
        }
        reader.readAsDataURL(file)
      } else {
        this.fileUrl = null
      }
    },
    closeReportView () {
      this.isOpenReportView = false
      this.loading = false
      this.initialDoc = ''
    },
    save () {
      this.stopEdit()
      setTimeout(() => {
        this.close()
      }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
#simple-info-block {
  width: 100%;
  display: flex;
  justify-content: end;

  ::v-deep .v-card {
    box-shadow: none;
    border-radius: 0px !important;
    width: 100%;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px -1px 0px 0px #EDF2F7 inset;
      background-color: #F7FAFC;
      border-radius: 16px;
      color: #1A202C;
      font-weight: 500;
      font-size: 16px;
      padding: 10px 15px;

      &.is-practitioner {
        cursor: pointer;
      }
    }

    .info-text {
      color: #1A202C;
      font-weight: 400;
      font-size: 16px;
      padding: 15px;
      line-height: 22px;
      overflow-y: auto;
      max-height: 300px;
    }

    &__actions {
      padding: 0;
    }

    textarea {
      color: #1A202C;
      font-weight: 400;
      font-size: 16px;
      padding: 15px;
      line-height: 22px;
      overflow-y: auto;
      max-height: 300px;
    }
  }
}

.show-notes {
  position: absolute;
  right: 10%;
}

.action-edit {
  width: 26px;
  height: 26px;
  cursor: pointer;
}
</style>
